var classes = {"root":"ieaVA","linkUnderline":"KQtnJ","icons":"XqqHZ"};

export { classes as default };
